const SCREEN_SIZES = {
    'md': '1080px',
    'sm': '800px',
}

export default SCREEN_SIZES;